var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconArrowDropdownBgc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-dropdown",
    "data-name": "Icon ionic-md-arrow-dropdown",
    d: "M9,13.5l7,7,7-7Z",
    transform: "translate(-9 -13.5)",
    fill: "#ccc"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArrowDropdownBgc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-arrow-dropdown-bgc.ecad0005.svg";
export { ForwardRef as ReactComponent };